import { cygnusIconHtml } from '@root/services/cygnusIconMarkup';

export default function buttonColumn(field, icon, cellClick, title = '', condition = (cell) => true) {
  return {
    formatter: (cell) =>
        condition(cell) ? `<button class="btn" type="button" title="${title}">${cygnusIconHtml(icon)}</button>` : '',
    width: 40,
    hozAlign: "center",
    vertAlign: "middle",
    cellClick: (e, cell) => condition(cell) ? cellClick(e, cell) : undefined,
    resizable: false,
    headerSort: false,
  };
}
